import { AppErrorCard } from '@components/error-card/app-error-card';
import { ScreenReaderElement } from '@components/screen-reader/screen-reader-element';
import { StandardButton } from '@eika/button';
import { useProcess } from '@react-query/hooks/query/use-process';
import { useTranslation } from '@translations';

export const GetProcessError = () => {
    const { error, refetch } = useProcess();
    const { tryAgain, pendingProcess } = useTranslation();

    if (!error) {
        return null;
    }

    return (
        <AppErrorCard description={pendingProcess.error} exception={error}>
            <ScreenReaderElement text={pendingProcess.error} role="alert" />
            <StandardButton
                onClick={() => {
                    refetch();
                }}
            >
                {tryAgain}
            </StandardButton>
        </AppErrorCard>
    );
};
